import {HttpClient, HttpHeaders} from "@angular/common/http";
import {URLSearchParams} from "@angular/http";
import {Injectable} from "@angular/core";
import {UrlSegment} from "@angular/router";
import "rxjs/add/operator/toPromise";
import {MessageService} from "./message.service";
import {LoginUserService} from "./login-user.service";
import {log} from "util";

// export const IMAGE_BASE__URL = 'http://api.2017.cshixi.com/';
// export const IMAGE_BASE__URL = 'http://api.2017.cshixi.com/';
// export const BACKEND_API_URL = 'http://api.newc.com//';

// export const BACKEND_API_URL = "http://localhost:4200/api/";
// export const IMAGE_BASE__URL = "http://localhost:4200/api";
export const BACKEND_API_URL = "http://www.xzhipin.com/api/";
export const IMAGE_BASE__URL = "http://www.xzhipin.com";

@Injectable()
export class CusHttp {
  token: string = "";

  constructor(
    private _http: HttpClient,
    private _msg: MessageService,
    private _login: LoginUserService
  ) {
    this.token = this._login.getToken();
    this._login.token$.subscribe((resp: string) => {
      this.token = resp;
      // console.log("Authorization", this.token);
    });
  }

  public get(url: string, params?: Object) {
    // console.log('get请求开始');
    // console.log('params', params);
    let subparams;
    // console.log(this.token);
    let a = this.token === undefined ? '' : this.token;
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + a);
    // extParams.append('Authorization', this.token);
    // if (params) {
    //   subparams = Object.assign(params, extParams);
    // } else {
    //   subparams = Object.assign({}, extParams);
    // }
    return this._http
      .get(BACKEND_API_URL + url, {headers})
      .toPromise()
      .then(this.handleSuccess)
      .catch(res => this.handleError(res));
  }

  public post(url: string, body: any, options?: Object) {
    let postbody;
    // console.log(body);
    const headers = new HttpHeaders().append("Authorization", "Bearer " + this.token);
    if (typeof body === "string") {
      postbody = body;
      headers.append("Content-Type", "application/x-www-form-urlencoded");
    } else if (body instanceof URLSearchParams) {
      // console.log("UP");
      const d = {};
      const str = body.toString();
      str.split('&').forEach(rec => {
        const p = rec.split('=');
        d[p[0]] = decodeURIComponent(p[1]);
      });
      postbody = d;

    } else if (body instanceof FormData) {
      postbody = body;
    } else {
      headers.append("Content-Type", "application/json");
      postbody = body;
    }
    // console.log(headers);
    return this._http
      .post(BACKEND_API_URL + url, postbody, {headers})
      .toPromise()
      .then(this.handleSuccess)
      .catch(res => this.handleError(res));
  }

  public put(url: string, body: any, options?: Object) {
    let postbody;
    let ctype: boolean = true;
    if (typeof body === "string") {
      postbody = body;
    } else if (body instanceof URLSearchParams) {
      postbody = body.toString();
    } else if (body instanceof FormData) {
      postbody = body;
      ctype = false;
    } else {
      let tmp;
      for (let i in body) {
        tmp.push(`${i}=${body[i]}`);
      }
      postbody = tmp.join("&");
    }
    let subparams;
    const headers = new HttpHeaders().append(
      "Authorization",
      "Bearer " + this.token
    );
    if (ctype) {
      headers.append("Content-Type", "application/x-www-form-urlencoded");
    }

    return this._http
      .put(BACKEND_API_URL + url, postbody, {headers})
      .toPromise()
      .then(this.handleSuccess)
      .catch(res => this.handleError(res));
  }

  public delete(url: string, params?: Object) {
    // console.log('get请求开始');
    // console.log('params', params);
    let subparams;
    const headers = new HttpHeaders().append(
      "Authorization",
      "Bearer " + this.token
    );

    return this._http
      .delete(BACKEND_API_URL + url, {headers})
      .toPromise()
      .then(this.handleSuccess)
      .catch(err => this.handleError(err));
  }

  private handleSuccess(res: any) {
    // const body = res['_body'];
    if (res) {
      return {
        data: res.data || {},
        _links: res._links || {},
        pagination: res.pagination || res._meta || {},
        statusText: res.statusText || {},
        status: res.status,
        success: true
      };
    } else {
      return {statusText: res.statusText, status: res.status, success: true};
    }
  }

  private handleError(error) {
    console.log("error:", error);
    let msg = "请求失败";
    if (error.status === 400) {
      console.log("请求参数正确");
    }
    if (error.status === 401) {
      console.log("未登录或登录超时,请登录");
      msg = "未登录或登录超时,请登录";
      // this._login.signOut();
    }

    if (error.status === 403) {
      console.error("已经经过身份验证的用户不允许访问指定的 API 末端");
    }

    if (error.status === 404) {
      console.error("所请求的资源不存在");
    }

    if (error.status === 405) {
      console.error("不被允许的方法。 请检查 Allow header 允许的HTTP方法");
    }

    if (error.status === 415) {
      console.error("不支持的媒体类型。 所请求的内容类型或版本号是无效的。");
    }

    if (error.status === 422) {
      error.error && error.error.map(abc => this._msg.error(abc.message));
      console.error("数据验证失败 (例如，响应一个 POST 请求)。 请检查响应体内详细的错误消息。");
    }

    if (error.status === 429) {
      console.error("请求过多。 由于限速请求被拒绝");
    }

    if (error.status === 500) {
      console.error("请求的服务器错误");
    }
    return {success: false, msg: msg, status: error.status};
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/services/CusHttp.ts